import "./ActionText.scss";

export const approveText = (
  <span className="actionText text-success fw-bold">
    <i
      className="bi bi-check-circle d-inline-block"
      style={{ strokeWidth: "5px", stroke: "white" }}
    ></i>
    <span className=" "> Approve</span>
  </span>
);

export const unresolveText = (
  <span className="unresolveText text-muted ">
    <i
      className="bi bi-arrow-clockwise d-inline-block"
      style={{ strokeWidth: "5px", stroke: "white" }}
    ></i>
    <span className=" "> Unresolve</span>
  </span>
);
